// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import Navbar from "../Navbar";
// import SelectSearchInput from "../SelectSearch";
// import { DownloadTableExcel } from "react-export-table-to-excel";
// import Footer from "../Footer";
// import { toast } from "react-toastify";
// import Select from 'react-select'
// import { FaEdit, FaSave, FaTimesCircle, FaTrashAlt } from "react-icons/fa";
// import StatementModal from "./StatementModal";
// import { useLocation } from "react-router-dom";

// const Statement = () => {
//   const [data, setData] = useState([]);
//   // const [date, setDate] = useState("");
//   const [token, setToken] = useState("");
//   const [selectedOutlet, setSelectedOutlet] = useState("");
//   const [company, setCompany] = useState("");
//   const [error, setErrorMsg] = useState("");
//   const tableRef = useRef(null);
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [formData, setFormData] = useState({
//     GroupName: '',
//     ItemName: '',
//     BrandName: '',
//     // vendor_name: '',
//     UOM: '',
//     CurrentLevel: 0,
//     Rate: '',
//     Total: 0,
//     Type: 'Food',
//     itemUnit: 0,
//     itemUom: ''
//   });

//   const uomOptions = ['kg', 'gm', 'ltr', 'ml', 'pcs', 'box', 'packet', 'unit', 'bottle', 'case', 'bunch'];
//   const unitUomOptions = ['kg', 'gm', 'ltr', 'ml', 'pcs', 'packet', 'unit', 'bottle'];
//   const typeOptions = ['Food', 'Beverage', 'Others'];

//   const { state } = useLocation();
//   const { viewMode } = state || {};

//   useEffect(() => {
//     localStorage.setItem("viewMode", JSON.stringify(viewMode));
//   }, [viewMode])

//   const itemOptions = useMemo(() => {
//     return data.flatMap(group =>
//       group.stocks.map(item => ({
//         value: item.ItemName,
//         label: `${item.ItemName} (${group.group})`,
//         group: group.group,
//         item
//       }))
//     );
//   }, [data]);

//   const filteredData = useMemo(() => {
//     if (!searchTerm) return data;

//     return data
//       .map(group => ({
//         ...group,
//         stocks: group.stocks.filter(item =>
//           item.ItemName.toLowerCase() === searchTerm.toLowerCase()
//         )
//       }))
//       .filter(group => group.stocks.length > 0);
//   }, [data, searchTerm]);

//   const changeOutlet = (e, companyName) => {
//     setSelectedOutlet(e);
//     setCompany(companyName);
//   };

//   const baseUrl = process.env.REACT_APP_BASE_URL;

//   useEffect(() => {
//     setToken(localStorage.getItem("token"));
//   }, []);

//   const fetchData = async () => {
//     setErrorMsg("");
//     try {
//       const response = await axios.post(`${baseUrl}/getstocksbygroup`, {
//         token: token,
//         outlet_name: selectedOutlet,
//       });
//       const dataWithEditing = response.data.map(group => ({
//         ...group,
//         stocks: group.stocks.map(item => ({
//           ...item,
//           isEditing: false,
//           editValues: {
//             GroupName: group.group,
//             BrandName: item.BrandName,
//             UOM: item.UOM,
//             CurrentLevel: item.CurrentLevel,
//             Rate: item.Rate,
//             Total: item.Total,
//             Type: item.Type || 'Food'
//           }
//         }))
//       }));
//       setData(dataWithEditing);

//       // const res = await axios.post(`${baseUrl}/getlatestsyncdate`, {
//       //   token: token,
//       //   outlet_name: selectedOutlet,
//       // });
//       // setDate(res.data.last_synced);
//     } catch (error) {
//       console.error("Error fetching data", error);
//       if (error.response && error.response.data) {
//         setErrorMsg(
//           error.response.data.message || "No stock records found."
//         );
//       } else {
//         setErrorMsg("An Error Occurred.");
//       }
//     }
//   };

//   useEffect(() => {
//     if (token && selectedOutlet) {
//       fetchData();
//     }
//   }, [token, selectedOutlet]);

//   const handleModalClose = () => setShowModal(false);
//   const handleModalShow = () => setShowModal(true);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     if (name === 'CurrentLevel' || name === 'Rate') {
//       setFormData(prev => {
//         const currentLevel = parseFloat(name === 'CurrentLevel' ? value : prev.CurrentLevel) || 0;
//         const rate = parseFloat(name === 'Rate' ? value : prev.Rate) || 0;
//         return {
//           ...prev,
//           Total: (currentLevel * rate).toFixed(2)
//         };
//       });
//     }
//   };

//   const handleEditItem = (groupIndex, itemIndex) => {
//     const newData = [...data];
//     newData[groupIndex].stocks[itemIndex].isEditing = true;
//     setData(newData);
//   };

//   const handleCancelEdit = (groupIndex, itemIndex) => {
//     const newData = [...data];
//     newData[groupIndex].stocks[itemIndex].isEditing = false;
//     setData(newData);
//   };

//   const handleEditChange = (groupIndex, itemIndex, e) => {
//     const { name, value } = e.target;
//     const newData = [...data];

//     newData[groupIndex].stocks[itemIndex].editValues[name] = value;

//     if (name === 'CurrentLevel' || name === 'Rate') {
//       const currentLevel = parseFloat(name === 'CurrentLevel' ? value : newData[groupIndex].stocks[itemIndex].editValues.CurrentLevel) || 0;
//       const rate = parseFloat(name === 'Rate' ? value : newData[groupIndex].stocks[itemIndex].editValues.Rate) || 0;
//       newData[groupIndex].stocks[itemIndex].editValues.Total = (currentLevel * rate).toFixed(2);
//     }

//     setData(newData);
//   };

//   const handleSaveEdit = async (groupIndex, itemIndex) => {
//     toast.info(
//       <div className="p-2">
//         <p className="mb-3 text-white">Are you sure you want to save these changes?</p>
//         <div className="flex justify-between gap-2">
//           <button
//             className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
//             onClick={async () => {
//               toast.dismiss();
//               const item = data[groupIndex].stocks[itemIndex];
//               const updatedItem = {
//                 ...item,
//                 ...item.editValues,
//               };

//               try {
//                 await axios.post(`${baseUrl}/updatestocks`, {
//                   token: token,
//                   outlet_name: selectedOutlet,
//                   stocks: [updatedItem]
//                 });
//                 toast.success('Item updated successfully');
//                 fetchData();
//               } catch (error) {
//                 console.error('Error updating item:', error);
//                 toast.error('Failed to update item');
//               }
//             }}
//           >
//             Save
//           </button>
//           <button
//             className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//             onClick={() => toast.dismiss()}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//         toastId: 'save-update-stock'
//       }
//     );
//   };

//   const handleDeleteItem = async (groupIndex, itemIndex) => {
//     toast.info(
//       <div className="p-2">
//         <p className="mb-3 text-white">Are you sure you want to delete this stock?</p>
//         <div className="flex justify-between gap-2">
//           <button
//             className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
//             onClick={async () => {
//               toast.dismiss();
//               const item = data[groupIndex].stocks[itemIndex];
//               try {
//                 await axios.post(`${baseUrl}/deletestocks`, {
//                   token: token,
//                   outlet_name: selectedOutlet,
//                   items: [
//                     item.ItemName
//                   ]
//                 });
//                 toast.success('Item deleted successfully');
//                 fetchData();
//               } catch (error) {
//                 console.error('Error deleting item:', error);
//                 const errorMessage =
//                   error?.response?.data?.not_deleted?.join(', ') ||
//                   error?.response?.data?.error ||
//                   error?.error ||
//                   "Failed to delete item";
//                 toast.error(errorMessage);
//               }
//             }}
//           >
//             Delete
//           </button>
//           <button
//             className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//             onClick={() => toast.dismiss()}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//         toastId: 'save-update-stock'
//       }
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       await axios.post(`${baseUrl}/stock-statement`, {
//         token: token,
//         items: [{
//           ...formData,
//           OutletName: selectedOutlet
//         }]
//       });
//       toast.success('Stock statement successfully created');

//       if (formData.itemUnit && formData.itemUom) {
//         try {
//           const payload = {
//             token: token,
//             outlet: selectedOutlet,
//             items: [{
//               name: formData.ItemName,
//               unit: parseFloat(formData.itemUnit),
//               uom: formData.itemUom,
//               rate: parseFloat(formData.Rate)
//             }]
//           };

//           await axios.post(`${baseUrl}/unit-definitions`, payload);
//           toast.success('Unit definition successfully created');
//         } catch (error) {
//           console.error('Error saving unit definitions:', error);
//           toast.error('Failed to save unit definitions');
//         }
//       }

//       handleModalClose();
//       fetchData();

//       setFormData({
//         GroupName: '',
//         ItemName: '',
//         BrandName: '',
//         UOM: '',
//         CurrentLevel: 0,
//         Rate: '',
//         Total: 0,
//         Type: 'Food',
//         itemUnit: 0,
//         itemUom: ''
//       })
//     } catch (err) {
//       toast.error('Failed to create stock statement');
//       console.log(err.response?.data?.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Navbar />
//       <div className="flex-grow">
//         <div className="font-sans mx-auto max-w-6xl p-4">
//           <div className="flex justify-center">
//             <SelectSearchInput
//               selectedOutlet={selectedOutlet}
//               setSelectedOutlet={changeOutlet}
//               token={token}
//             />
//           </div>

//           <div className="flex justify-between items-center my-4">
//             <DownloadTableExcel
//               filename="statement"
//               sheet="Outlet"
//               currentTableRef={tableRef.current}>
//               <button className="export">
//                 Export
//               </button>
//             </DownloadTableExcel>

//             <div className="w-80">
//               <Select
//                 options={itemOptions}
//                 placeholder="Search items..."
//                 isClearable
//                 onChange={(selectedOption) => {
//                   if (selectedOption) {
//                     setSearchTerm(selectedOption.value);
//                   } else {
//                     setSearchTerm("");
//                   }
//                 }}
//                 styles={{
//                   control: (provided) => ({
//                     ...provided,
//                     border: '1px solid #e2e8f0',
//                     borderRadius: '0.375rem',
//                     boxShadow: 'none',
//                     '&:hover': {
//                       borderColor: '#cbd5e0',
//                     },
//                   }),
//                   option: (provided, state) => ({
//                     ...provided,
//                     backgroundColor: state.isSelected ? '#4299e1' : state.isFocused ? '#ebf8ff' : 'white',
//                     color: state.isSelected ? 'white' : 'black',
//                   }),
//                 }}
//               />
//             </div>

//             <button
//               onClick={handleModalShow}
//               className="border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-lg flex items-center justify-center px-3 py-2 text-sm"
//             >
//               Add Stock
//             </button>
//           </div>

//           {error ? (
//             <p className="text-center text-red-500">{error}</p>
//           ) : (
//             <div ref={tableRef}>
//               <table className="border-collapse mt-4 w-full">
//                 <thead>
//                   <tr>
//                     <th colSpan={8}>
//                       <div className="flex flex-col justify-end">
//                         <h1 className="text-3xl text-center underline">
//                           {company}
//                         </h1>

//                         {decodeURIComponent(selectedOutlet) ? (
//                           <h1 className="text-lg text-center font-medium font-poppins md:text-xl">
//                             {decodeURIComponent(selectedOutlet || "") || ""}
//                           </h1>
//                         ) : (
//                           <h1 className="text-lg text-center font-medium font-poppins md:text-xl">
//                             {decodeURIComponent(selectedOutlet || "") || ""}
//                           </h1>
//                         )}

//                         {/* <p className="text-center underline">
//                           Stock Statement Report For: {date}
//                         </p> */}
//                       </div>
//                     </th>
//                   </tr>
//                   <tr>
//                     <th className="p-1 text-center font-bold underline text-lg">Group Name</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Item Name</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Brand Name</th>
//                     <th className="p-1 text-center font-bold underline text-lg">UOM</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Current Level</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Rate</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Total</th>
//                     <th className="p-1 text-center font-bold underline text-lg">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.map((group, groupIndex) => (
//                     <React.Fragment key={groupIndex}>
//                       <tr>
//                         <td
//                           className="font-bold capitalize p-2 border-b-2 border-black text-center text-base"
//                           colSpan="1">
//                           {group.group}
//                         </td>
//                       </tr>
//                       {group.stocks.map((item, itemIndex) => (
//                         <tr key={itemIndex}>
//                           <td className="p-1 text-center"></td>
//                           <td className="p-1 text-center text-sm">{item.ItemName}</td>
//                           <td className="p-1 text-center">
//                             {item.isEditing ? (
//                               <input
//                                 type="text"
//                                 name="BrandName"
//                                 value={item.editValues.BrandName}
//                                 onChange={(e) => handleEditChange(groupIndex, itemIndex, e)}
//                                 className="w-32 text-center px-2 py-1 border rounded"
//                               />
//                             ) : (
//                               <span className="text-sm text-black">{item.BrandName}</span>
//                             )}
//                           </td>
//                           <td className="p-1 text-center">
//                             {item.isEditing ? (
//                               <input
//                                 type="text"
//                                 name="UOM"
//                                 value={item.editValues.UOM}
//                                 onChange={(e) => handleEditChange(groupIndex, itemIndex, e)}
//                                 className="w-32 text-center px-2 py-1 border rounded"
//                               />
//                             ) : (
//                               <span className="text-sm text-black">{item.UOM}</span>
//                             )}
//                           </td>
//                           <td className="p-1 text-center">
//                             {item.isEditing ? (
//                               <input
//                                 type="number"
//                                 name="CurrentLevel"
//                                 value={item.editValues.CurrentLevel}
//                                 onChange={(e) => handleEditChange(groupIndex, itemIndex, e)}
//                                 min="0"
//                                 step="0.01"
//                                 className="w-32 text-center px-2 py-1 border rounded"
//                               />
//                             ) : (
//                               <span className="text-sm text-black">{item.CurrentLevel}</span>
//                             )}
//                           </td>
//                           <td className="p-1 text-center">
//                             {item.isEditing ? (
//                               <input
//                                 type="number"
//                                 name="Rate"
//                                 value={item.editValues.Rate}
//                                 onChange={(e) => handleEditChange(groupIndex, itemIndex, e)}
//                                 min="0"
//                                 step="0.01"
//                                 className="w-32 text-center px-2 py-1 border rounded"
//                               />
//                             ) : (
//                               <span className="text-sm text-black">{item.Rate}</span>
//                             )}
//                           </td>
//                           <td className="p-1 text-center">
//                             <span className="text-sm text-black">
//                               {item.isEditing ? item.editValues.Total : item.Total}
//                             </span>
//                           </td>
//                           <td className="p-1 text-center text-sm">
//                             {item.isEditing ? (
//                               <div className="flex justify-center space-x-2">
//                                 <button
//                                   onClick={() => handleSaveEdit(groupIndex, itemIndex)}
//                                   className="h-8 w-8 p-0 border rounded flex items-center justify-center text-green-600 hover:bg-green-50"
//                                 >
//                                   <FaSave className="h-4 w-4" />
//                                 </button>
//                                 <button
//                                   onClick={() => handleCancelEdit(groupIndex, itemIndex)}
//                                   className="h-8 w-8 p-0 border rounded flex items-center justify-center text-red-600 hover:bg-red-50"
//                                 >
//                                   <FaTimesCircle className="h-4 w-4" />
//                                 </button>
//                               </div>
//                             ) : (
//                               <div className="flex justify-center space-x-2">
//                                 <button
//                                   onClick={() => handleEditItem(groupIndex, itemIndex)}
//                                   className="h-8 w-8 p-0 border rounded flex items-center justify-center text-blue-600 hover:bg-blue-50"
//                                 >
//                                   <FaEdit className="h-4 w-4" />
//                                 </button>
//                                 <button
//                                   onClick={() => handleDeleteItem(groupIndex, itemIndex)}
//                                   className="h-8 w-8 p-0 border rounded flex items-center justify-center text-red-600 hover:bg-red-50"
//                                 >
//                                   <FaTrashAlt className="h-4 w-4" />
//                                 </button>
//                               </div>
//                             )}
//                           </td>
//                         </tr>
//                       ))}

//                       {!searchTerm && (
//                         <tr>
//                           <td colSpan="6" className="p-1 text-center"></td>
//                           <td className="p-1 text-center text-sm font-bold border-t border-black">
//                             {group.group_total.toFixed(2)}
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))}

//                   <tr>
//                     <td colSpan={7} className="p-2"></td>
//                   </tr>

//                   {!searchTerm && (
//                     <tr>
//                       <td colSpan="6" className="p-1 text-center"></td>
//                       <td className="p-1 text-center text-sm font-bold border-t-2 border-black">
//                         {data
//                           .reduce((acc, group) => acc + group.group_total, 0)
//                           .toFixed(2)}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>

//         <StatementModal
//           showModal={showModal}
//           handleModalClose={handleModalClose}
//           handleChange={handleChange}
//           handleSubmit={handleSubmit}
//           formData={formData}
//           uomOptions={uomOptions}
//           unitUomOptions={unitUomOptions}
//           typeOptions={typeOptions}
//           loading={loading}
//         />
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Statement;

























// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import Navbar from "../Navbar";
// import Footer from "../Footer";
// import { toast } from "react-toastify";
// import Select from 'react-select'
// import StatementModal from "./StatementModal";
// import { useStock } from "../../context/StockProvider";
// import OutletSearch from "../SelectSearch/OutletSearch";
// import * as XLSX from "xlsx";
// import { formatSalesValue } from './../../utils/formatUtils';
// import StatementTable from "./StatementTable";
// import { selectStyles } from "../../utils/cssUtils";

// const Statement = () => {
//   const tableRef = useRef(null);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [editName, setEditName] = useState("");

//   const [showModal, setShowModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedGroup, setSelectedGroup] = useState("");

//   const { stockItems, stockLoading, stockError, fetchStockData } = useStock();
//   const [selectedOutlet, setSelectedOutlet] = useState("");
//   const company = localStorage.getItem("selectedCompany");
//   const baseUrl = process.env.REACT_APP_BASE_URL;
//   const token = localStorage.getItem("token");

//   const groupOptions = useMemo(() => {
//     return data.map(group => ({
//       value: group.group,
//       label: group.group,
//     }));
//   }, [data]);

//   const itemOptions = useMemo(() => {
//     const source = selectedGroup ? data.filter(g => g.group === selectedGroup) : data;

//     return source.flatMap(group =>
//       group.stocks.map(item => ({
//         value: item.ItemName,
//         label: `${item.ItemName} (${group.group})`,
//         group: group.group,
//         item
//       }))
//     );
//   }, [data, selectedGroup]);

//   const filteredData = useMemo(() => {
//     let result = data;

//     if (selectedGroup) {
//       result = result.filter(group => group.group === selectedGroup);
//     }

//     if (searchTerm) {
//       result = result
//         .map(group => ({
//           ...group,
//           stocks: group.stocks.filter(item =>
//             item.ItemName.toLowerCase() === searchTerm.toLowerCase()
//           )
//         }))
//         .filter(group => group.stocks.length > 0);
//     }

//     return result;
//   }, [data, searchTerm, selectedGroup]);

//   useEffect(() => {
//     if (!stockItems) return;

//     const grouped = stockItems.reduce((acc, item) => {
//       const groupName = item.GroupName || "Ungrouped";

//       if (!acc[groupName]) {
//         acc[groupName] = {
//           group: groupName,
//           stocks: [],
//           group_total: 0
//         };
//       }

//       const newItem = {
//         ...item,
//         isEditing: false,
//         editValues: {
//           primary_unit: item.UOM,
//           secondary_unit: item.secondary_unit || "",
//           CurrentLevel: item.CurrentLevel,
//           Rate: item.Rate,
//           Total: item.CurrentLevel * item.Rate,
//         },
//       };

//       acc[groupName].stocks.push(newItem);
//       acc[groupName].group_total += item.CurrentLevel * item.Rate;

//       return acc;
//     }, {});

//     setData(Object.values(grouped));
//   }, [stockItems]);

//   const handleModalClose = () => setShowModal(false);
//   const handleModalShow = () => setShowModal(true);

//   const getItemId = (item) =>
//     `${item.ItemName}-${item.GroupName}`;

//   const handleEditItem = (id) => {
//     setData(
//       data.map(group => ({
//         ...group,
//         stocks: group.stocks.map(item =>
//           getItemId(item) === id
//             ? { ...item, isEditing: true }
//             : item
//         )
//       }))
//     );
//   };

//   const handleCancelEdit = (id) => {
//     setData(
//       data.map(group => ({
//         ...group,
//         stocks: group.stocks.map(item =>
//           getItemId(item) === id
//             ? { ...item, isEditing: false }
//             : item
//         )
//       }))
//     );
//   };

//   const handleEditChange = (id, e) => {
//     const { name, value } = e.target;

//     setData(
//       data.map(group => ({
//         ...group,
//         stocks: group.stocks.map(item => {
//           if (getItemId(item) !== id) {
//             return item;
//           }

//           const updatedEditValues = {
//             ...item.editValues,
//             [name]: value,
//           };

//           if (name === "CurrentLevel" || name === "Rate") {
//             const currentLevel =
//               parseFloat(updatedEditValues.CurrentLevel) || 0;

//             const rate =
//               parseFloat(updatedEditValues.Rate) || 0;

//             updatedEditValues.Total = (
//               currentLevel * rate
//             ).toFixed(2);
//           }

//           return {
//             ...item,
//             editValues: updatedEditValues,
//           };
//         }),
//       }))
//     );
//   };

//   const handleSaveEdit = async (id) => {
//     const item = data
//       .flatMap(group => group.stocks)
//       .find(item => getItemId(item) === id);

//     if (!item) return;

//     toast.info(
//       <div className="p-2">
//         <p className="mb-3 text-white">
//           Are you sure you want to save these changes?
//         </p>

//         <div className="flex justify-between gap-2">

//           <button
//             className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
//             onClick={async () => {
//               toast.dismiss();

//               const updatedItem = {
//                 ...item,
//                 ...item.editValues,
//               };

//               try {
//                 await axios.post(`${baseUrl}/updatestocks`, {
//                   token,
//                   outlet_name: selectedOutlet,
//                   stocks: [updatedItem]
//                 });

//                 toast.success("Item updated successfully");

//                 fetchStockData(token, selectedOutlet);

//               } catch (error) {
//                 console.error("Error updating item:", error);

//                 toast.error(
//                   error?.response?.data?.message ||
//                   error?.response?.data?.error ||
//                   "Failed to update item"
//                 );
//               }
//             }}
//           >
//             Save
//           </button>

//           <button
//             className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//             onClick={() => toast.dismiss()}
//           >
//             Cancel
//           </button>

//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//         toastId: "save-update-stock"
//       }
//     );
//   };

//   const handleDeleteItem = async (id) => {
//     const item = data
//       .flatMap(group => group.stocks)
//       .find(item => getItemId(item) === id);

//     if (!item) return;

//     toast.info(
//       <div className="p-2">

//         <p className="mb-3 text-white">
//           Are you sure you want to delete this stock?
//         </p>

//         <div className="flex justify-between gap-2">

//           <button
//             className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
//             onClick={async () => {

//               toast.dismiss();

//               try {

//                 await axios.post(
//                   `${baseUrl}/deletestocks`,
//                   {
//                     token,
//                     outlet_name:
//                       selectedOutlet,

//                     items: [
//                       item.ItemName
//                     ]
//                   }
//                 );

//                 toast.success(
//                   "Item deleted successfully"
//                 );

//                 setSearchTerm("");

//                 fetchStockData(
//                   token,
//                   selectedOutlet
//                 );

//               } catch (error) {

//                 console.error(
//                   "Error deleting item:",
//                   error
//                 );

//                 const errorMessage =
//                   error?.response?.data?.not_deleted?.join(", ") ||
//                   error?.response?.data?.error ||
//                   error?.error ||
//                   "Failed to delete item";

//                 toast.error(errorMessage);
//               }
//             }}
//           >
//             Delete
//           </button>

//           <button
//             className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//             onClick={() => toast.dismiss()}
//           >
//             Cancel
//           </button>

//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//         toastId: "delete-stock"
//       }
//     );
//   };

//   const updateConfirmation = (itemName, newName) => {
//     toast.info(
//       <div className="p-2">
//         <p className="mb-3 text-white">Are you sure you want to update item name for {itemName}?</p>

//         <div className="flex justify-between gap-2">
//           <button
//             className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
//             onClick={async () => {
//               toast.dismiss();

//               try {
//                 const payload = {
//                   outlet_name: selectedOutlet,
//                   old_item_name: itemName,
//                   new_item_name: newName
//                 };

//                 await axios.post(`${baseUrl}/updatestockitemname`, payload);

//                 setEditingId(null);
//                 setSearchTerm("")
//                 toast.success("Item name updated successfully!");

//                 fetchStockData(token, selectedOutlet);

//               } catch (err) {
//                 console.error(err);
//                 toast.error(err?.response?.data?.error || err?.response?.data?.message || err?.message || "Error updating item name");
//               }
//             }}
//           >
//             Update
//           </button>

//           <button
//             className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//             onClick={() => toast.dismiss()}
//           >
//             Cancel
//           </button>
//         </div>
//       </div >,
//       {
//         autoClose: false,
//         closeButton: false,
//       }
//     );
//   };

//   const exportToExcel = () => {
//     const wb = XLSX.utils.book_new();
//     const rows = [];

//     // ── Title block ──────────────────────────────────────────────────────────
//     rows.push([company]);
//     rows.push([decodeURIComponent(selectedOutlet || "")]);
//     rows.push([]);

//     // ── Column headers (mirrors StatementTable) ───────────────────────────────
//     rows.push([
//       "Item Name",
//       "Brand",
//       "Level",
//       "Primary Unit",
//       "Secondary Unit",
//       "Rate",
//       "Total",
//       "Unit Definition",
//     ]);

//     // ── Data ─────────────────────────────────────────────────────────────────
//     filteredData.forEach((group) => {
//       // Group header row — spans all columns visually via empty cells
//       rows.push([group.group, "", "", "", "", "", "", ""]);

//       group.stocks.forEach((item) => {
//         // Unit definition: collapse all defs to "unit (uom)" strings
//         const unitDefText =
//           item.unit_definitions && item.unit_definitions.length > 0
//             ? item.unit_definitions
//               .map((d) => `${d.unit} (${d.uom})`)
//               .join(", ")
//             : "";

//         rows.push([
//           item.ItemName,
//           item.BrandName || "",
//           item.CurrentLevel,
//           item.primary_unit || item.UOM || "",
//           item.secondary_unit || "",
//           parseFloat(item.Rate) || 0,
//           parseFloat(item.Total) || 0,
//           unitDefText,
//         ]);
//       });

//       // Group total row
//       if (!searchTerm) {
//         rows.push([
//           "",
//           "",
//           "",
//           "",
//           "",
//           "Group Total",
//           parseFloat(group.group_total) || 0,
//           "",
//         ]);
//       }

//       // Blank spacer between groups
//       rows.push([]);
//     });

//     // ── Grand total ───────────────────────────────────────────────────────────
//     if (!searchTerm) {
//       rows.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "Grand Total",
//         data.reduce((acc, g) => acc + (parseFloat(g.group_total) || 0), 0),
//         "",
//       ]);
//     }

//     const ws = XLSX.utils.aoa_to_sheet(rows);

//     // Merge title rows across all 8 columns
//     ws["!merges"] = [
//       { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
//       { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } },
//     ];

//     ws["!cols"] = [
//       { wch: 30 }, // Item Name
//       { wch: 18 }, // Brand
//       { wch: 12 }, // Level
//       { wch: 14 }, // Primary Unit
//       { wch: 14 }, // Secondary Unit
//       { wch: 12 }, // Rate
//       { wch: 14 }, // Total
//       { wch: 20 }, // Unit Definition
//     ];

//     XLSX.utils.book_append_sheet(wb, ws, "Outlet");
//     XLSX.writeFile(wb, "statement.xlsx");
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Navbar />

//       <div className="flex-grow py-3">
//         <div className="font-sans mx-auto max-w-6xl">
//           <div className="flex justify-center mb-2.5">
//             <OutletSearch
//               selectedOutlet={selectedOutlet}
//               setSelectedOutlet={setSelectedOutlet}
//               token={token}
//               compact={true}
//             />
//           </div>

//           <div className="flex justify-between items-center mb-3">
//             <button
//               className="px-4 py-1.5 rounded-md font-medium bg-emerald-100 text-emerald-800 hover:bg-emerald-200 hover:shadow-md text-sm transition"
//               onClick={exportToExcel}
//             >
//               Export
//             </button>

//             <div className="w-56">
//               <Select
//                 options={groupOptions}
//                 placeholder="Filter by group..."
//                 isClearable
//                 value={selectedGroup ? { value: selectedGroup, label: selectedGroup } : null}
//                 onChange={(selectedOption) => {
//                   setSelectedGroup(selectedOption ? selectedOption.value : "");
//                 }}
//                 styles={selectStyles}
//               />
//             </div>

//             <div className="w-96">
//               <Select
//                 options={itemOptions}
//                 placeholder="Search items..."
//                 isClearable
//                 onChange={(selectedOption) => {
//                   if (selectedOption) {
//                     setSearchTerm(selectedOption.value);
//                   } else {
//                     setSearchTerm("");
//                   }
//                 }}
//                 styles={selectStyles}
//               />
//             </div>

//             <button
//               onClick={handleModalShow}
//               className="px-4 py-1.5 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm transition"
//             >
//               Add Stock
//             </button>
//           </div>

//           {stockError ? (
//             <p className="text-center text-red-500">{stockError}</p>
//           ) : stockLoading ? (
//             <p className="text-center">Loading...</p>
//           ) : (
//             <StatementTable
//               tableRef={tableRef}
//               company={company}
//               selectedOutlet={selectedOutlet}
//               filteredData={filteredData}
//               searchTerm={searchTerm}
//               data={data}
//               editingId={editingId}
//               editName={editName}
//               setEditingId={setEditingId}
//               setEditName={setEditName}
//               updateConfirmation={updateConfirmation}
//               handleEditChange={handleEditChange}
//               handleSaveEdit={handleSaveEdit}
//               handleCancelEdit={handleCancelEdit}
//               handleEditItem={handleEditItem}
//               handleDeleteItem={handleDeleteItem}
//               formatSalesValue={formatSalesValue}
//             />
//           )}
//         </div>

//         <StatementModal
//           showModal={showModal}
//           handleModalClose={handleModalClose}
//           loading={loading}
//           token={token}
//           baseUrl={baseUrl}
//           selectedOutlet={selectedOutlet}
//           setLoading={setLoading}
//           fetchStockData={fetchStockData}
//         />
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Statement;




















// Hot Topic

import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { toast } from "react-toastify";
import Select from 'react-select'
import StatementModal from "./StatementModal";
import { useStock } from "../../context/StockProvider";
import OutletSearch from "../SelectSearch/OutletSearch";
import * as XLSX from "xlsx";
import { formatSalesValue } from './../../utils/formatUtils';
import StatementTable from "./StatementTable";

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "38px",
    height: "38px",
    fontSize: "0.875rem",
    borderColor: state.isFocused ? "#9333ea" : "#d1d5db",
    borderRadius: "0.375rem",
    boxShadow: state.isFocused ? "0 0 0 1px #9333ea" : "none",
    "&:hover": {
      borderColor: "#9333ea",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
    fontSize: "0.875rem",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: "0.875rem",
  }),

  singleValue: (base) => ({
    ...base,
    fontSize: "0.875rem",
  }),

  placeholder: (base) => ({
    ...base,
    fontSize: "0.875rem",
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "38px",
  }),

  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 6px",
  }),

  clearIndicator: (base) => ({
    ...base,
    padding: "0 6px",
  }),

  menu: (base) => ({
    ...base,
    zIndex: 50,
    fontSize: "0.875rem",
  }),

  option: (base, state) => ({
    ...base,
    fontSize: "0.875rem",
    backgroundColor: state.isSelected
      ? "#9333ea"
      : state.isFocused
        ? "#f3e8ff"
        : "white",
    color: state.isSelected ? "white" : "#111827",
    "&:active": {
      backgroundColor: "#9333ea",
      color: "white",
    },
  }),
};

const roundTo2 = (num) => {
  const n = Number(num);
  if (!isFinite(n)) return 0;
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

const Statement = () => {
  const [data, setData] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const company = localStorage.getItem("selectedCompany")
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");

  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const { stockItems, stockLoading, stockError, fetchStockData } = useStock();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");

  const filteredData = useMemo(() => {
    if (!searchTerm) return data;

    return data
      .map(group => ({
        ...group,
        stocks: group.stocks.filter(item =>
          item.ItemName.toLowerCase() === searchTerm.toLowerCase()
        )
      }))
      .filter(group => group.stocks.length > 0);
  }, [data, searchTerm]);

  const itemOptions = useMemo(() => {
    return data.flatMap(group =>
      group.stocks.map(item => ({
        value: item.ItemName,
        label: `${item.ItemName} (${group.group})`,
        group: group.group,
        item
      }))
    );
  }, [data]);

  useEffect(() => {
    if (!stockItems) return;

    const grouped = stockItems.reduce((acc, item) => {
      const groupName = item.GroupName || "Ungrouped";

      if (!acc[groupName]) {
        acc[groupName] = {
          group: groupName,
          stocks: [],
          group_total: 0
        };
      }

      const newItem = {
        ...item,
        isEditing: false,
        editValues: {
          GroupName: item.GroupName,
          BrandName: item.BrandName,
          UOM: item.UOM,
          CurrentLevel: item.CurrentLevel,
          Rate: item.Rate,
          Total: roundTo2(item.CurrentLevel * item.Rate),
          Type: item.Department || 'Food',
          primary_unit: item.primary_unit || item.UOM || "",
          secondary_unit: item.secondary_unit || "",
        }
      };

      acc[groupName].stocks.push(newItem);
      acc[groupName].group_total = roundTo2(acc[groupName].group_total + item.CurrentLevel * item.Rate);

      return acc;
    }, {});

    setData(Object.values(grouped));
  }, [stockItems]);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const getItemId = (item) =>
    `${item.ItemName}-${item.GroupName}`;

  const handleEditItem = (id) => {
    setData(
      data.map(group => ({
        ...group,
        stocks: group.stocks.map(item =>
          getItemId(item) === id
            ? { ...item, isEditing: true }
            : item
        )
      }))
    );
  };

  const handleCancelEdit = (id) => {
    setData(
      data.map(group => ({
        ...group,
        stocks: group.stocks.map(item =>
          getItemId(item) === id
            ? { ...item, isEditing: false }
            : item
        )
      }))
    );
  };

  const handleEditChange = (id, e) => {
    const { name, value } = e.target;

    setData(
      data.map(group => ({
        ...group,
        stocks: group.stocks.map(item => {
          if (getItemId(item) !== id) {
            return item;
          }

          const updatedEditValues = {
            ...item.editValues,
            [name]: value,
          };

          if (name === "CurrentLevel" || name === "Rate") {
            const currentLevel = parseFloat(updatedEditValues.CurrentLevel) || 0;
            const rate = parseFloat(updatedEditValues.Rate) || 0;

            updatedEditValues.Total = roundTo2(currentLevel * rate);
          }

          return {
            ...item,
            editValues: updatedEditValues,
          };
        }),
      }))
    );
  };

  const handleSaveEdit = async (id) => {
    const item = data
      .flatMap(group => group.stocks)
      .find(item => getItemId(item) === id);

    if (!item) return;

    toast.info(
      <div className="p-2">
        <p className="mb-3 text-white">
          Are you sure you want to save these changes?
        </p>

        <div className="flex justify-between gap-2">

          <button
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            onClick={async () => {

              toast.dismiss();

              const updatedItem = {
                ...item,
                ...item.editValues,
              };

              try {
                await axios.post(`${baseUrl}/updatestocks`, {
                  token,
                  outlet_name: selectedOutlet,
                  stocks: [updatedItem]
                });

                toast.success("Item updated successfully");
                fetchStockData(token, selectedOutlet);

              } catch (error) {
                console.error("Error updating item:", error);

                toast.error(
                  error?.response?.data?.message ||
                  error?.response?.data?.error ||
                  "Failed to update item"
                );
              }
            }}
          >
            Save
          </button>

          <button
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>

        </div>
      </div>,
      {
        autoClose: false,
        closeButton: false,
        toastId: "save-update-stock"
      }
    );
  };

  const handleDeleteItem = async (id) => {
    const item = data
      .flatMap(group => group.stocks)
      .find(item => getItemId(item) === id);

    if (!item) return;

    toast.info(
      <div className="p-2">

        <p className="mb-3 text-white">
          Are you sure you want to delete this stock?
        </p>

        <div className="flex justify-between gap-2">

          <button
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            onClick={async () => {

              toast.dismiss();

              try {

                await axios.post(
                  `${baseUrl}/deletestocks`,
                  {
                    token,
                    outlet_name:
                      selectedOutlet,

                    items: [
                      item.ItemName
                    ]
                  }
                );

                toast.success(
                  "Item deleted successfully"
                );

                setSearchTerm("");

                fetchStockData(
                  token,
                  selectedOutlet
                );

              } catch (error) {

                console.error(
                  "Error deleting item:",
                  error
                );

                const errorMessage =
                  error?.response?.data?.not_deleted?.join(", ") ||
                  error?.response?.data?.error ||
                  error?.error ||
                  "Failed to delete item";

                toast.error(errorMessage);
              }
            }}
          >
            Delete
          </button>

          <button
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>

        </div>
      </div>,
      {
        autoClose: false,
        closeButton: false,
        toastId: "delete-stock"
      }
    );
  };

  const updateConfirmation = (itemName, newName) => {
    toast.info(
      <div className="p-2">
        <p className="mb-3 text-white">Are you sure you want to update item name for {itemName}?</p>

        <div className="flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            onClick={async () => {
              toast.dismiss();

              try {
                const payload = {
                  outlet_name: selectedOutlet,
                  old_item_name: itemName,
                  new_item_name: newName
                };

                await axios.post(`${baseUrl}/updatestockitemname`, payload);

                setEditingId(null);
                setSearchTerm("")
                toast.success("Item name updated successfully!");

                fetchStockData(token, selectedOutlet);

              } catch (err) {
                console.error(err);
                toast.error(err?.response?.data?.error || err?.response?.data?.message || err?.message || "Error updating item name");
              }
            }}
          >
            Update
          </button>

          <button
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            onClick={() => toast.dismiss()}
          >
            Cancel
          </button>
        </div>
      </div >,
      {
        autoClose: false,
        closeButton: false,
      }
    );
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    const rows = [];

    rows.push([company]);
    rows.push([decodeURIComponent(selectedOutlet || "")]);
    rows.push([]);

    rows.push([
      "Group Name",
      "Item Name",
      "Brand Name",
      "UOM",
      "Current Level",
      "Rate",
      "Total"
    ]);

    filteredData.forEach((group) => {
      rows.push([group.group]);

      group.stocks.forEach((item) => {
        rows.push([
          "",
          item.ItemName,
          item.BrandName,
          item.UOM,
          item.CurrentLevel,
          item.Rate,
          item.Total,
        ]);
      });

      if (!searchTerm) {
        rows.push([
          "",
          "",
          "",
          "",
          "",
          "Group Total",
          group.group_total,
        ]);
      }

      rows.push([]);
    });

    if (!searchTerm) {
      rows.push([
        "",
        "",
        "",
        "",
        "",
        "Grand Total",
        data.reduce((acc, g) => acc + g.group_total, 0),
      ]);
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);

    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
    ];

    // Auto column width
    ws["!cols"] = [
      { wch: 20 },
      { wch: 25 },
      { wch: 20 },
      { wch: 10 },
      { wch: 15 },
      { wch: 10 },
      { wch: 15 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Outlet");
    XLSX.writeFile(wb, "statement.xlsx");
  };

  // ── Column order used by both the template and the parser ──────────────────
  const TEMPLATE_COLUMNS = [
    "GroupName",
    "BrandName",
    "ItemName",
    "UOM",
    "currentLevel",
    "Rate",
    "taxable",
    "Department",
    "StockType",
    "Vendor",
    "exp_date",
    "primary_unit",
    "secondary_unit",
    "unitdefinition_unit",
    "unitdefinition_uom",
  ];

  // ── Download a blank template the user can fill in ──────────────────────────
  const handleDownloadTemplate = () => {
    // ── File 1: empty template ────────────────────────────────────────────────
    const wbEmpty = XLSX.utils.book_new();
    const wsEmpty = XLSX.utils.aoa_to_sheet([TEMPLATE_COLUMNS]);
    wsEmpty["!cols"] = TEMPLATE_COLUMNS.map(() => ({ wch: 18 }));
    XLSX.utils.book_append_sheet(wbEmpty, wsEmpty, "Stocks");
    XLSX.writeFile(wbEmpty, "stock_upload_template.xlsx");

    // ── File 2: same template pre-filled with realistic sample data ────────────
    const sampleRows = [
      {
        GroupName: "Bakery",
        BrandName: "",
        ItemName: "Burger Bun",
        UOM: "Pkt",
        currentLevel: 25,
        Rate: 30,
        taxable: "FALSE",
        Department: "Food",
        StockType: "Stockable",
        Vendor: "Himalayan Bakers Pvt. Ltd.",
        exp_date: "2026-08-15",
        primary_unit: "Pkt",
        secondary_unit: "grms",
        unitdefinition_unit: 1000,
        unitdefinition_uom: "Grms",
      },
      {
        GroupName: "Dairy",
        BrandName: "Amul",
        ItemName: "Fresh Cream",
        UOM: "ltr",
        currentLevel: 12.5,
        Rate: 390,
        taxable: "TRUE",
        Department: "Food",
        StockType: "Stockable",
        Vendor: "Dairy Fresh Distributors",
        exp_date: "2026-07-20",
        primary_unit: "ltr",
        secondary_unit: "ml",
        unitdefinition_unit: 1000,
        unitdefinition_uom: "ml",
      },
      {
        GroupName: "Cold Beverage",
        BrandName: "Real",
        ItemName: "Cranberry Juice",
        UOM: "ltr",
        currentLevel: 8,
        Rate: 220,
        taxable: "TRUE",
        Department: "Beverage",
        StockType: "Stockable",
        Vendor: "Nepal Beverage Suppliers",
        exp_date: "2027-01-10",
        primary_unit: "ltr",
        secondary_unit: "ml",
        unitdefinition_unit: 1000,
        unitdefinition_uom: "ml",
      },
      {
        GroupName: "Bakery",
        BrandName: "",
        ItemName: "Cheese Cake",
        UOM: "pcs",
        currentLevel: 6,
        Rate: 1100,
        taxable: "FALSE",
        Department: "Food",
        StockType: "Stockable",
        Vendor: "Friends Bakery",
        exp_date: "2026-07-05",
        primary_unit: "pcs",
        secondary_unit: "pcs",
        unitdefinition_unit: 1,
        unitdefinition_uom: "pcs",
      },
      {
        GroupName: "Spices",
        BrandName: "Everest",
        ItemName: "Garam Masala",
        UOM: "kg",
        currentLevel: 4.25,
        Rate: 850,
        taxable: "TRUE",
        Department: "Food",
        StockType: "Stockable",
        Vendor: "Spice World Traders",
        exp_date: "2027-03-30",
        primary_unit: "kg",
        secondary_unit: "gram",
        unitdefinition_unit: 1000,
        unitdefinition_uom: "Grms",
      },
      {
        GroupName: "Crockery",
        BrandName: "Borosil",
        ItemName: "Dinner Plate 10in",
        UOM: "pcs",
        currentLevel: 40,
        Rate: 150,
        taxable: "TRUE",
        Department: "Food",
        StockType: "Non-Stockable",
        Vendor: "Hotel Supplies Nepal",
        exp_date: "",
        primary_unit: "pcs",
        secondary_unit: "pcs",
        unitdefinition_unit: 1,
        unitdefinition_uom: "pcs",
      },
      {
        GroupName: "Bar Equipment",
        BrandName: "",
        ItemName: "Cocktail Shaker",
        UOM: "pcs",
        currentLevel: 5,
        Rate: 650,
        taxable: "FALSE",
        Department: "Beverage",
        StockType: "Non-Stockable",
        Vendor: "Bar Pro Equipment",
        exp_date: "",
        primary_unit: "pcs",
        secondary_unit: "pcs",
        unitdefinition_unit: 1,
        unitdefinition_uom: "pcs",
      },
      {
        GroupName: "Vegetables",
        BrandName: "",
        ItemName: "Fresh Tomato",
        UOM: "kg",
        currentLevel: 15,
        Rate: 80,
        taxable: "FALSE",
        Department: "Food",
        StockType: "Stockable",
        Vendor: "Local Farm Suppliers",
        exp_date: "",
        primary_unit: "kg",
        secondary_unit: "gram",
        unitdefinition_unit: 1000,
        unitdefinition_uom: "Grms",
      },
    ];

    const sampleAoa = [
      TEMPLATE_COLUMNS,
      ...sampleRows.map((row) => TEMPLATE_COLUMNS.map((col) => row[col] ?? "")),
    ];

    const wbSample = XLSX.utils.book_new();
    const wsSample = XLSX.utils.aoa_to_sheet(sampleAoa);
    wsSample["!cols"] = TEMPLATE_COLUMNS.map(() => ({ wch: 18 }));
    XLSX.utils.book_append_sheet(wbSample, wsSample, "Stocks");
    XLSX.writeFile(wbSample, "stock_upload_template_sample.xlsx");
  };

  // ── Trigger hidden file input ────────────────────────────────────────────────
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  // ── Parse the uploaded file and post to /poststocks ──────────────────────────
  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!selectedOutlet) {
      toast.error("Please select an outlet first");
      e.target.value = "";
      return;
    }

    setUploading(true);

    try {
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data, { type: "array" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      if (!rows.length) {
        toast.error("The uploaded file has no data rows");
        return;
      }

      const ItemDetailsList = rows.map((row) => {
        const currentLevel = roundTo2(parseFloat(row.currentLevel) || 0);
        const rate = roundTo2(parseFloat(row.Rate) || 0);

        return {
          GroupName: row.GroupName || "",
          BrandName: row.BrandName || "",
          ItemName: row.ItemName || "",
          UOM: row.UOM || "",
          currentLevel,
          Rate: rate,
          Total: roundTo2(currentLevel * rate),
          OutletName: selectedOutlet,
          Department: row.Department || "",
          Vendor: row.Vendor || "",
          exp_date: row.exp_date ? row.exp_date : null,
          taxable:
            String(row.taxable).toLowerCase() === "true" ||
            row.taxable === true,
          primary_unit: row.primary_unit || row.UOM || "",
          secondary_unit: row.secondary_unit || row.UOM || "",
          StockType: row.StockType || "Stockable",
          unitdefinition: {
            unit: roundTo2(parseFloat(row.unitdefinition_unit) || 1),
            uom: row.unitdefinition_uom || row.UOM || "",
            rate,
          },
        };
      });

      const invalidRows = ItemDetailsList.filter((item) => !item.ItemName);
      if (invalidRows.length) {
        toast.error("Some rows are missing an Item Name. Please fix and re-upload.");
        return;
      }

      const payload = {
        ItemDetailsList,
        OutletName: selectedOutlet,
      };

      await axios.post(`${baseUrl}/poststocks`, payload);

      toast.success(`${ItemDetailsList.length} item(s) uploaded successfully!`);
      fetchStockData(token, selectedOutlet);
    } catch (error) {
      console.error("Error uploading stock sheet:", error);
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to upload stock sheet"
      );
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow">
        <div className="mx-auto max-w-6xl p-3">
          <div className="mb-2.5">
            <div className="flex justify-center mb-2.5">
              <OutletSearch
                selectedOutlet={selectedOutlet}
                setSelectedOutlet={setSelectedOutlet}
                token={token}
                compact
              />
            </div>

            <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
              {/* Left: primary actions */}
              <div className="flex flex-wrap items-center gap-2">
                <button
                  onClick={handleModalShow}
                  className="px-4 py-2 rounded-md font-medium bg-purple-600 text-white text-sm
                    transition-all duration-200 ease-out
                    hover:bg-purple-700 hover:shadow-md hover:-translate-y-0.5
                    active:translate-y-0 active:scale-[0.98]"
                >
                  + Add Stock
                </button>

                <div className="h-6 w-px bg-gray-300 mx-1 hidden sm:block" />

                <button
                  className="px-3 py-2 rounded-md font-medium bg-white border border-gray-300 text-gray-700 text-sm
                    transition-all duration-200 ease-out
                    hover:bg-gray-50 hover:border-gray-400 hover:shadow-sm hover:-translate-y-0.5
                    active:translate-y-0 active:scale-[0.98]"
                  onClick={exportToExcel}
                >
                  Export
                </button>

                <button
                  className="px-3 py-2 rounded-md font-medium bg-white border border-gray-300 text-gray-700 text-sm
                    transition-all duration-200 ease-out
                    hover:bg-gray-50 hover:border-gray-400 hover:shadow-sm hover:-translate-y-0.5
                    active:translate-y-0 active:scale-[0.98]"
                  onClick={handleDownloadTemplate}
                >
                  Download Template
                </button>

                <button
                  className="px-3 py-2 rounded-md font-medium bg-white border border-gray-300 text-gray-700 text-sm
                    transition-all duration-200 ease-out
                    hover:bg-gray-50 hover:border-gray-400 hover:shadow-sm hover:-translate-y-0.5
                    active:translate-y-0 active:scale-[0.98]
                    disabled:opacity-50 disabled:cursor-not-allowed
                    disabled:hover:bg-white disabled:hover:shadow-none disabled:hover:translate-y-0
                    disabled:active:scale-100"
                  onClick={handleUploadClick}
                  disabled={uploading || !selectedOutlet}
                  title={!selectedOutlet ? "Select an outlet first" : undefined}
                >
                  {uploading ? (
                    <span className="flex items-center gap-2">
                      <span className="h-3.5 w-3.5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
                      Uploading...
                    </span>
                  ) : (
                    "Upload Excel"
                  )}
                </button>

                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx,.xls"
                  className="hidden"
                  onChange={handleFileUpload}
                />
              </div>

              {/* Right: search */}
              <div className="w-full sm:w-80">
                <Select
                  options={itemOptions}
                  placeholder="Search items..."
                  isClearable
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setSearchTerm(selectedOption.value);
                    } else {
                      setSearchTerm("");
                    }
                  }}
                  styles={selectStyles}
                />
              </div>
            </div>
          </div>

          {stockError ? (
            <p className="text-center text-red-500">{stockError}</p>
          ) : stockLoading ? (
            <p className="text-center">Loading...</p>
          ) : (
            <StatementTable
              company={company}
              selectedOutlet={selectedOutlet}
              filteredData={filteredData}
              searchTerm={searchTerm}
              data={data}
              editingId={editingId}
              editName={editName}
              setEditingId={setEditingId}
              setEditName={setEditName}
              updateConfirmation={updateConfirmation}
              handleEditChange={handleEditChange}
              handleSaveEdit={handleSaveEdit}
              handleCancelEdit={handleCancelEdit}
              handleEditItem={handleEditItem}
              handleDeleteItem={handleDeleteItem}
              formatSalesValue={formatSalesValue}
            />
          )}
        </div>

        <StatementModal
          showModal={showModal}
          handleModalClose={handleModalClose}
          loading={loading}
          token={token}
          baseUrl={baseUrl}
          selectedOutlet={selectedOutlet}
          setLoading={setLoading}
          fetchStockData={fetchStockData}
        />
      </div>

      <Footer />
    </div>
  );
};

export default Statement;